import Box from 'v2/components/UI/Box';
import Icon from 'v2/components/Icon';
import Text from 'v2/components/UI/Text';
import Select from 'v2/components/Select';
import MultiSelectAll from 'components/MultiSelect';
import LineChart from '../../UI/LineChart';
import useBiometricsParameters from './hooks/useBiometricsParameters';

const BiometricsParameters = () => {
  const {
    optionsParameters,
    optionsnNurseries,
    selectedParameter,
    selectedNurseries,

    handleChangeParameters,
    setSelectedNurseries,
  } = useBiometricsParameters();

  const renderTextEmptyMessageOrGraph = () => {
    if (optionsParameters.length === 2 && optionsnNurseries.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Nenhum dado encontrado
          </Text>
        </Box>
      );
    }

    if (selectedNurseries.length === 0) {
      return (
        <Box>
          <Text fontSize={16} fontWeight={700} color="#5f1300">
            Selecione ao menos um viveiro
          </Text>
        </Box>
      );
    }

    return <LineChart data={selectedNurseries} />;
  };

  return (
    <Box
      flexDirection="column"
      gap={30}
      padding={30}
      background="#fff"
      borderRadius={18}
    >
      <Box gap={10} alignItems="center">
        <Icon iconName="TroubleshootOutlined" htmlColor="#005f47" size={30} />
        <Text fontSize={24} fontWeight={700} color="#005f47">
          Biometria por Parâmetros
        </Text>
      </Box>

      <Box gap={20}>
        <Select
          backgroundColor="#b7ffbd"
          options={optionsParameters}
          value={selectedParameter}
          labelId="supplies-label"
          selectId="supplies-id"
          label="Parâmetros"
          onChange={handleChangeParameters}
          defaultValue={'default'}
        />

        <Box>
          <MultiSelectAll
            label="Viveiros"
            id="shrimppond"
            allSelected={
              optionsnNurseries?.length === optionsParameters?.length
            }
            labelOption="name"
            onChange={setSelectedNurseries}
            options={optionsnNurseries}
            value={selectedNurseries}
            error={false}
            helperText={false}
            renderOptionLabel={false}
            labelSelectAllButtonFilterOptions={false}
            labelCustomRenderOption={false}
          />
        </Box>
      </Box>
      {renderTextEmptyMessageOrGraph()}
    </Box>
  );
};

export default BiometricsParameters;
